import { Card } from "@mui/material";
import { LazerTraderStrategyWrapper } from "../../features/lazertrader";

const AlgoFrame = () => {
  return (
    <Card
      sx={{
        width: "100%",
        height: "100%",
        backgroundColor: (t) => t.palette.background.paper,
      }}
      elevation={5}
    >
      <LazerTraderStrategyWrapper />
    </Card>
  );
};

export { AlgoFrame };
